import { autoLockRulesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOCKED_FIELDS_ACTION_TYPE = createNamedActions('lockedFields', {
  GET_LOCKED_FIELDS: 'GET_LOCKED_FIELDS',
});

export const getApplicationLockedFields = catchAsyncActionError(params => async dispatch => {
  const { data } = await autoLockRulesApi.getApplicationLockedFields(params);

  return dispatch({
    type: LOCKED_FIELDS_ACTION_TYPE.GET_LOCKED_FIELDS,
    payload: data,
  });
});
